module.exports = __webpack_public_path__ + "img/dsg-01.prt.1cb0e809.jpg";